import React from "react";

const ServicesSection = ({ part }) => {
  const data_1 = [
    { n: 1, name: "Html 5" },
    { n: 2, name: "Css 3" },
    { n: 3, name: "Sass" },
    { n: 4, name: "TailwindCSS" },
    { n: 5, name: "JavaScript" },
    { n: 6, name: "TypeScript" },
    { n: 7, name: "React" },
    { n: 8, name: "Redux" },
    { n: 9, name: "NextJS" },
  ];

  const data_2 = [
    { n: 11, name: "RNative" },
    { n: 12, name: "JestJS" },
    { n: 20, name: "Playwright" },
    { n: 13, name: "NodeJS" },
    { n: 24, name: "Docker" },
    { n: 14, name: "CI / CD" },
    { n: 17, name: "Git" },
  ];

  const skills = part === 1 ? data_1 : data_2;

  return (
    <section
      id="ServicesSection"
      className="max-w-[768px] flex flex-col items-center justify-between space-y-10 py-4 px-12"
    >
      {part === 1 && (
        <div className="space-y-4">
          <h1 className="text-3xl text-center leading-tight">
            Skills <span>💡</span>
          </h1>
          <p className="text-center text-sm font-normal leading-loose opacity-60">
            Those are all the technologies that I know & love to use.
          </p>
        </div>
      )}

      <ul className="w-full grid grid-cols-2 items-center justify-between gap-x-24 gap-y-10 px-4 text-sm font-normal leading-loose opacity-80 xl:grid-cols-3">
        {skills.map((icon, i) => {
          return (
            <li
              key={i}
              className="bg-white cursor-pointer flex flex-col items-center justify-center space-y-2 p-6 shadow-2xl rounded-full"
            >
              <img
                alt="skills-icon"
                src={`/images/Skills/${icon.n}.png`}
                className="w-10 h-10"
              ></img>
              <p className="text-base font-normal leading-loose opacity-90">
                {icon.name}
              </p>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ServicesSection;
